import Send from '../../send';

const DEFAULT_API = '/v1/footer-info';
export default {
    getFooterInfo(siteInfoSeq) {
        return Send({
            url: `${DEFAULT_API}`,
            method: 'GET',
            params: {
                siteInfoSeq: siteInfoSeq
            }
        });
    }
}